'use strict';
import classNames from 'classnames';
import get from 'lodash/get';
import * as T from 'prop-types';
import React, {Component, Fragment} from 'react';
import {Button} from '../../../../../components/buttons/Button';
import {ValidationErrorMessages} from '../../../../../components/forms/ValidationErrorMessages';
import {DateTimePicker} from '../../../../../components/temporal/DateTimePicker';
import {cachedFmtDate, cachedFmtTime} from '../utils';


export class DateFieldEditView extends Component {
  static propTypes = {
    field: T.object.isRequired,
    isSaving: T.bool.isRequired,
    onChange: T.func.isRequired,
    onClear: T.func.isRequired,
    validationMessages: T.arrayOf(T.string),
  };

  render() {
    const props = this.props;
    const {options} = props.field;
    const result = props.value;

    const date = options.includeDate ? (
      <div
        className={classNames("DateFieldEdit__result", {
          DateFieldEdit__result_saving: props.isSaving,
        })}
      >
        {cachedFmtDate(result.value) || '--/--/--'}
      </div>
    ) : null;

    const time = options.includeTime ? (
      <div
        className={classNames("DateFieldEdit__result", {
          DateFieldEdit__result_saving: props.isSaving,
        })}
      >
        {cachedFmtTime(result.value) || '--:--'}
      </div>
    ) : null;

    return (
      <Fragment>
        <div
          className={classNames(`DateFieldEdit`, {
            DateFieldEdit_error: get(props.validationMessages, 'length'),
          })}
        >
          <Button
            className="DateFieldEdit__dates"
            onClick={props.onTogglePickerOpen}
            disabled={props.isSaving}
          >
            {date}
            {' '}
            {time}
          </Button>
        </div>
        <ValidationErrorMessages validationMessages={props.validationMessages} />
        {this.renderPicker()}
      </Fragment>
    );
  }

  renderPicker() {
    const props = this.props;
    const result = props.value;
    const {options} = props.field;

    return this.props.isPickerOpen ? (
      <DateTimePicker
        value={result.value}
        includeDate={options.includeDate}
        includeTime={options.includeTime}
        onCancel={props.onTogglePickerOpen}
        onChange={props.onChange}
        onClear={props.onClear}
      />
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/js/form-builder/components/response/fields/DateFieldEdit/DateFieldEditView.js